import React from 'react';

export type EmailSettings = {
  emailSubject: string;
  senderName: string;
  senderEmail: string;
  replyEmail: string;
};

export type EmailTemplate = {
  id: number;
  uuid: string;
  name: string;
  slug: string;
  schemaProviderId: number;
  updatedAt: string;
  isEmptyHtml: boolean;
} & EmailSettings;

export type TestEmail = {
  receiver: string;
  html: string;
};
export type EmailTemplateStatus = {
  errorMessages: React.ReactNode[];
} & EmailTemplate;

export enum EmailTemplateStatusType {
  subheader = 'subheader',
  card = 'card',
}